module.exports = __webpack_public_path__ + "static/media/google-ads-and-seo.59f58a2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/google-ads-and-seo.svg
// module id = 66
// module chunks = 0